import { faArrowRight } from '@awesome.me/kit-5452b20ec3/icons/classic/light'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Button from '../../form-elements/Button'
import styles from './FormContinueButton.module.scss'

interface FormContinueButtonProps {
  isFormComplete: boolean
}

export default function FormContinueButton({ isFormComplete }: FormContinueButtonProps) {
  return (
    <div className={styles['form-button-container']}>
      <Button disabled={!isFormComplete} Icon={<FontAwesomeIcon icon={faArrowRight} />} rounded type="submit">
        Continue
      </Button>
    </div>
  )
}
